import axios from 'axios'
import { REACT_APP_API_ABM } from '../../config'

export async function getCurrencies(exchangeRates = [], setCancelToken = null) {
  const headers = {}
  if (setCancelToken) {
    headers.cancelToken = new axios.CancelToken(setCancelToken)
  }

  try {
    const {
      data: { data }
    } = await axios(`${REACT_APP_API_ABM}/abms/currencies`, headers)
    let exchanges
    if (exchangeRates.length) {
      exchanges = exchangeRates
    } else {
      const {
        data: { data: exchangesResponse }
      } = await axios(`${REACT_APP_API_ABM}/abms/exchange-rates`, headers)
      exchanges = exchangesResponse
    }

    return { currencies: data, exchanges }
  } catch (error) {
    console.log(`Error getCurrencies `, error)
    throw new Error(error)
  }
}
